<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>{{ message.text }}</b>
      </div>
      <div class="form-group">
        <input name="otp"
               type="text"
               class="form-control"
               :class="{'form-alert': errors.has('otp')}"
               placeholder="OTP"
               v-model="otp"
               v-validate="'required'">
        <span v-show="errors.has('otp')" class="help text-danger">{{ errors.first('otp') }}</span>
      </div>
      <div class="form-group" v-if="!saveSuccess">
        <button class="btn btn-block btn-info" :disabled="loading" @click="submit">ยืนยัน</button>
        <div class="text-center mt-4" v-if="failureCode">
          <h3 class="text-danger">{{ getErrorMessage(failureCode) }}</h3>
          <div v-if="failureCode === 'expired_otp'">
            <button class="btn btn-outline-info btn-block" @click="resendOTP()">
              <i class="fal fa-redo"></i>
              {{ $t('message.verification.resend_code') }}
            </button>
          </div>
        </div>
      </div>
      <div class="text-center mt-4" v-else>
        <h3>
          <i class="fas fa-check-circle -status-accepted"></i> ยืนยันเบอร์โทรสำเร็จ
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    props: {
      message: Object
    },
    data () {
      return {
        otp: '',
        failureCode: null,
        validation: null,
        errorMessage: null,
        loading: false,
        saveSuccess: false
      }
    },
    computed: {
      ...mapGetters({user: 'auth/getUser'})
    },
    watch: {
      user () {
        if (this.user) {
          const action = {
            label: 'login',
            text: this.otp
          }
          this.sendMessage(action)
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getToken']),
      getErrorMessage (failureCode) {
        let errorMessage = null
        switch (failureCode) {
          case 'expired_otp':
            errorMessage = 'รหัส OTP หมดอายุ'
            break
          case 'invalid_otp':
            errorMessage = 'รหัส OTP ไม่ถูกต้อง'
            break
        }
        return errorMessage
      },
      resendOTP () {
        if (this.validation) {
          const submitData = {
            user_id: this.message.data.user_id
          }
          this.$store.dispatch('phoneVerification/RESEND_OTP', submitData)
        }
      },
      sendMessage (action) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: action.label,
          text: action.text,
          data: action.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      loginUser () {
        if (this.message.data.email) {
          const loginData = {
            email: this.message.data.email,
            social_name: 'email_password',
            token: null
          }
          this.$store.dispatch('auth/LOGIN', loginData)
        }
      },
      submit () {
        this.$validator.validate().then(valid => {
          if (valid) {
            this.loading = true
            const url = 'auth/check-otp'
            const submitData = {
              otp: this.otp,
              user_id: this.message.data.user_id
            }
            const queryParams = this.$route.query
            if (queryParams.ref) {
              submitData.referral_code = queryParams.ref
            }
            axios.post(url, submitData)
              .then(async (res) => {
                const response = res.data
                this.loading = false
                if (!response.error) {
                  this.saveSuccess = true
                  // Perform login user if OTP is valid
                  this.loginUser()
                } else {
                  this.failureCode = response.failure_code
                  this.validation = response.validation
                  // Get user token temporary for resend otp
                  const submitData = {
                    user_id: this.message.data.user_id,
                    validation: response.validation
                  }
                  await this.getToken(submitData)
                }
              })
              .catch(error => {
                this.loading = false
                console.log(error)
                this.$swal({text: error.message, type: 'error'})
              })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/OTPMessage.vue